// don't destructure `{ JwtDecode }` here, because it errors out on old ES5 projects (i.e. "eMarketer.Search.ResultsPage")
const JwtDecode = require('./jwt-decode').JwtDecode;

/**
 * Reads the access token from the provided JWT access token cookie and returns an object with the decoded token information.
 * @param {string} accessTokenCookie - The access token cookie.
 * @returns {Object} - An object containing the decoded access token information.
 */
function ReadAccessToken(accessTokenCookie) {
  const accessToken = JwtDecode(accessTokenCookie);
  const coalescedAccessToken = accessToken || {
    loginTypeId: '',
    jti: '',
    extranetId: '',
    pod: '',
    sub: '',
    given_name: '',
    exp: 0,
  };
  const authenticated = accessToken !== null;
  const isIpUser = authenticated && accessToken && accessToken.loginTypeId === '2';
  const pod = accessToken ? (accessToken.pod ? accessToken.pod : 'na1') : '';

  return {
    authenticated: authenticated,
    isIpUser: isIpUser,
    loginTypeId: coalescedAccessToken.loginTypeId,
    userId: coalescedAccessToken.jti,
    extranetId: coalescedAccessToken.extranetId,
    pod: pod.toLowerCase(),
    email: coalescedAccessToken.sub,
    firstName: coalescedAccessToken.given_name,
    expires: parseInt(coalescedAccessToken.exp, 10) || 0,
    tier: coalescedAccessToken.tier,
  };
}

/**
 * Checks if the provided access token has the specified role.
 * @param {string} accessToken - The JWT access token.
 * @param {string} role - The role to check.
 * @returns {boolean} - Returns true if the access token has the specified role, otherwise returns false.
 */
function IsInRole(accessToken, role) {
  const jwtPayload = JwtDecode(accessToken);

  if (jwtPayload === null) return false;

  const coalescedRoles = jwtPayload.roles || { roles: '[]' };
  const roles = JSON.parse(coalescedRoles);

  if (typeof roles === typeof []) {
    return roles.indexOf(role) > -1;
  }

  return false;
}

module.exports = {
  ReadAccessToken: ReadAccessToken,
  IsInRole: IsInRole,
  JwtDecode: JwtDecode,
};
